var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7048 26.0398H19.3633",
    stroke: "#171719",
    strokeWidth: 2.00307,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0337 28.7108V23.3693",
    stroke: "#171719",
    strokeWidth: 2.00307,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.238 14.5157C16.1045 14.5024 15.9442 14.5024 15.7973 14.5157C12.6191 14.4089 10.0953 11.8049 10.0953 8.59998C10.0819 5.3283 12.7393 2.6709 16.011 2.6709C19.2827 2.6709 21.9401 5.3283 21.9401 8.59998C21.9401 11.8049 19.4029 14.4089 16.238 14.5157Z",
    stroke: "#171719",
    strokeWidth: 2.00307,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0114 29.1244C13.581 29.1244 11.164 28.5101 9.32117 27.2816C6.08956 25.1183 6.08956 21.5929 9.32117 19.4429C12.9935 16.9858 19.016 16.9858 22.6883 19.4429",
    stroke: "#171719",
    strokeWidth: 2.00307,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/user-add.76137065.svg";
export { ForwardRef as ReactComponent };